export var Permission;
(function (Permission) {
    Permission[Permission["WERKORDER"] = 1] = "WERKORDER";
    Permission[Permission["URENENMATERIALEN"] = 2] = "URENENMATERIALEN";
    Permission[Permission["CALCULATIE"] = 3] = "CALCULATIE";
    Permission[Permission["WBESTELLINGEN"] = 4] = "WBESTELLINGEN";
    Permission[Permission["WBIJLAGEN"] = 5] = "WBIJLAGEN";
    Permission[Permission["KLANTEN"] = 6] = "KLANTEN";
    Permission[Permission["WPPLANNING"] = 7] = "WPPLANNING";
    Permission[Permission["LEVERANCIERS"] = 8] = "LEVERANCIERS";
    Permission[Permission["ARTIKELEN"] = 9] = "ARTIKELEN";
    Permission[Permission["OFFERTE"] = 10] = "OFFERTE";
    Permission[Permission["FACTUREN"] = 11] = "FACTUREN";
    Permission[Permission["BESTELLINGEN"] = 12] = "BESTELLINGEN";
    Permission[Permission["BEHEER"] = 13] = "BEHEER";
    Permission[Permission["INKOOPFACTUREN"] = 14] = "INKOOPFACTUREN";
    Permission[Permission["DOCUMENTATIE"] = 15] = "DOCUMENTATIE";
})(Permission || (Permission = {}));
export var PermissionType;
(function (PermissionType) {
    PermissionType[PermissionType["Create"] = 0] = "Create";
    PermissionType[PermissionType["Read"] = 1] = "Read";
    PermissionType[PermissionType["Update"] = 2] = "Update";
    PermissionType[PermissionType["Delete"] = 3] = "Delete";
})(PermissionType || (PermissionType = {}));
